/* eslint-disable no-undef */
(() => {
  // ---------- Helpers ----------
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => root.querySelectorAll(sel);
// tiny event-delegation helper
const on = (el, evt, selOrHandler, handler, options = {}) => {
  if (!el) return;
  const opts = { passive: false, capture: false, ...options };

  if (typeof selOrHandler === 'function') {
    el.addEventListener(evt, selOrHandler, opts);
    return;
  }
  el.addEventListener(
    evt,
    e => {
      const match = e.target.closest(selOrHandler);
      if (match && el.contains(match)) handler(e, match);
    },
    opts
  );
};

  // ---------- One-time IE popup (per session) ----------
  try {
    if (sessionStorage.getItem('popupSeen') !== '1' && document.documentMode) {
      sessionStorage.setItem('popupSeen', '1');
      const browserCheck = $('#browserCheck');
      if (browserCheck) {
        browserCheck.classList.add('ie');
        // delegate close to container to avoid attaching many listeners
        on(browserCheck, 'click', '.popupCloseButton', () => {
          browserCheck.style.display = 'none';
        });
      }
    }
  } catch (_) {
    // Fail silently if sessionStorage is blocked
  }

  // ---------- DOM Ready ----------
  document.addEventListener('DOMContentLoaded', () => {
    // ---------- URL Params handling ----------
    // Removed the 500ms timeout; if these inputs render later, we still set a sensible default.
    const params = new URLSearchParams(window.location.search);

    const activateForm = id => {
      const el = document.getElementById(id);
      if (el) el.classList.add('active');
    };

    if (params.has('adtype')) {
      const formId = params.get('adtype') === 'slider' ? 'formSlider' : 'formVideo';
      activateForm(formId);
    } else if (params.has('pb_number')) {
      const brokerNumber = params.get('pb_number');
      const brokerField = document.getElementById('pb_number-4fddb9b4-2fdb-4c96-9ef4-4c6b67e351ee');
      const input = document.querySelector('input[name="pb_number"]');
      if (input) input.disabled = true;
      if (brokerField) brokerField.value = brokerNumber;
    } else if (params.has('baddr')) {
      const baddr = params.get('baddr');
      const baddrField = document.getElementById('your_baddr_id');
      if (baddrField) {
        baddrField.value = baddr;
        baddrField.disabled = true;
      }
    } else {
      activateForm('formVideo');
    }

    // ---------- GSAP + Smooth scrolling ----------
    if (window.gsap) {
      // Register plugins safely
      try {
        if (window.ScrollTrigger) gsap.registerPlugin(ScrollTrigger);
        if (window.ScrollToPlugin) gsap.registerPlugin(ScrollToPlugin);
      } catch (_) { /* no-op */ }

      // Smooth internal anchor scrolling (delegated)
      const getSamePageHash = link => {
        const { protocol, host, pathname, search } = window.location;
        return (
          link.protocol === protocol &&
          link.host === host &&
          link.pathname === pathname &&
          link.search === search &&
          link.hash
        ) ? link.hash : '';
      };

      on(document, 'click', 'a[href^="#"], a[href*="#"]', (e, link) => {
        const hash = getSamePageHash(link);
        if (!hash) return;
        const target = document.querySelector(hash);
        if (!target) return;
        e.preventDefault();
        if (window.ScrollToPlugin) {
          gsap.to(window, { scrollTo: target, duration: 0.8 });
        } else {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });

      // Scroll to initial hash on load
      if (location.hash) {
        const target = document.querySelector(location.hash);
        if (target) {
          if (window.ScrollToPlugin) {
            gsap.to(window, { scrollTo: target, duration: 0.8, delay: 0.05 });
          } else {
            setTimeout(() => target.scrollIntoView({ behavior: 'smooth' }), 50);
          }
        }
      }

      // ---------- Scroll-based animations ----------
      const headers = gsap.utils.toArray('.outline-header');
      const layers = gsap.utils.toArray('.layer');
      const reveals = gsap.utils.toArray('.reveal');

      // Outline headers
      for (const header of headers) {
        const fromBottom = header.classList.contains('outline-header_fromBottom');
        gsap.to(header, {
          scrollTrigger: {
            trigger: header,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 1
          },
          x: fromBottom ? 0 : -100,
          y: fromBottom ? -100 : 0
        });
      }

      // Layers toggle active
      for (const layer of layers) {
        gsap.to(layer, {
          scrollTrigger: {
            trigger: layer,
            start: 'top bottom',
            end: 'bottom top',
            toggleClass: { targets: layer, className: 'is-active' }
          }
        });
      }

      // Reveals
      for (const reveal of reveals) {
        gsap.to(reveal, {
          autoAlpha: 1,
          ease: 'power1.inOut',
          scrollTrigger: {
            trigger: reveal,
            start: 'top 33%',
            end: 'bottom top',
            scrub: 1,
            toggleClass: { targets: reveal, className: 'is-active' }
          }
        });
      }

      // Sticky header: show when scrolling up, hide when down + add .scrolled class
      const showHeader = gsap.from('header', {
        yPercent: -162,
        autoAlpha: 0,
        duration: 0.2,
        paused: true
      }).progress(1);

      if (window.ScrollTrigger) {
        ScrollTrigger.create({
          start: 0,
          end: 99999,
          onUpdate: self => {
            if (self.direction === -1) showHeader.play();
            else showHeader.reverse();
          },
          toggleClass: { targets: 'header', className: 'scrolled' }
        });
      }

      // Parallax hero image slide
      const imageSlide = $('.image-slide');
      if (imageSlide && window.ScrollTrigger) {
        gsap.to(imageSlide, {
          yPercent: 30,
          ease: 'none',
          scrollTrigger: { trigger: '#hero', scrub: 1 }
        });
      }
    }

    // ---------- Accessible Accordion ----------
    // Click to toggle; hidden state synced to aria-expanded
    for (const header of $$('[data-accordion-header]')) {
      const target = header.parentElement?.nextElementSibling;
      header.addEventListener('click', () => {
        const expanded = header.getAttribute('aria-expanded') === 'true';
        header.setAttribute('aria-expanded', String(!expanded));
        if (target) {
          target.hidden = expanded;
          if (!expanded) target.setAttribute('expanded', 'true');
          else target.removeAttribute('expanded');
        }
      }, { passive: true });
    }

    // ---------- Accessible Tabs ----------
   (() => {
      let sectionCount = 0;
      document.querySelectorAll('.tabs-section').forEach(initTabsSection);

      function initTabsSection(section) {
        const tablist = section.querySelector('[role="tablist"]');
        if (!tablist) return;

        const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
        if (!tabs.length) return;

        // Only the top-level tab panels (avoid nested accordions)
        const panels = Array.from(
          section.querySelectorAll('.tab-panels > .tab-panel[role="tabpanel"]')
        );

        const panelById = new Map(panels.map(p => [p.id, p]));
        const prefix = `tabs${++sectionCount}`;

        // Wire IDs and aria
        tabs.forEach((tab, i) => {
          const tabId = tab.id || `${prefix}-tab-${i + 1}`;
          tab.id = tabId;

          let panelId =
            tab.getAttribute('aria-controls') ||
            panels[i]?.id ||
            `${prefix}-panel-${i + 1}`;

          tab.setAttribute('aria-controls', panelId);

          const panel = panelById.get(panelId);
          if (panel) {
            if (!panel.id) panel.id = panelId;
            panel.setAttribute('aria-labelledby', tabId);
          }

          tab.setAttribute(
            'tabindex',
            tab.getAttribute('aria-selected') === 'true' ? '0' : '-1'
          );
        });

        // Initial selection
        let currentIndex = Math.max(
          0,
          tabs.findIndex(t => t.getAttribute('aria-selected') === 'true')
        );

        const prefersReduce = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
        const isMobile = () => window.innerWidth <= 768;

        function activate(index, { scrollOnMobile = false } = {}) {
          if (index < 0 || index >= tabs.length) return;

          // Hide all panels first
          panels.forEach(p => (p.hidden = true));

          tabs.forEach((t, i) => {
            const selected = i === index;
            t.setAttribute('aria-selected', String(selected));
            t.setAttribute('tabindex', selected ? '0' : '-1');
          });

          const activeTab = tabs[index];
          const panelId = activeTab.getAttribute('aria-controls');
          const panel = panelById.get(panelId);
          if (panel) panel.hidden = false;

          currentIndex = index; // keep in sync

          if (scrollOnMobile && isMobile() && panel) {
            const headerOffset = document.querySelector('header')?.offsetHeight ?? 0;
            const y = panel.getBoundingClientRect().top + window.pageYOffset - headerOffset;
            window.scrollTo({ top: y, behavior: prefersReduce ? 'auto' : 'smooth' });
          }
        }

        // Events
        tabs.forEach((tab, i) => {
          tab.addEventListener(
            'click',
            e => {
              e.preventDefault();
              activate(i, { scrollOnMobile: true });
              tab.focus({ preventScroll: true });
            },
            { passive: false }
          );

          tab.addEventListener(
            'keydown',
            e => {
              const { key } = e;
              let next = null;
              if (key === 'ArrowRight' || key === 'ArrowDown') next = (i + 1) % tabs.length;
              else if (key === 'ArrowLeft' || key === 'ArrowUp') next = (i - 1 + tabs.length) % tabs.length;
              else if (key === 'Home') next = 0;
              else if (key === 'End') next = tabs.length - 1;
              else if (key === 'Enter' || key === ' ') {
                e.preventDefault();
                activate(i);
                return;
              }

              if (next !== null) {
                e.preventDefault();
                tabs[next].focus();
              }
            },
            { passive: false }
          );
        });

        // Initialize state
        activate(currentIndex);
      }
    })();


    // ---------- Hover background: The Vision ----------
    const visionSection = $('.the-vision');
    if (visionSection) {
      for (const col of $$('.the-vision--column')) {
        col.addEventListener('mouseenter', () => {
          const bg = col.dataset.bgImage;
          if (bg) visionSection.style.backgroundImage = `url("${bg}")`;
        }, { passive: true });
      }
    }

    // ---------- Hover background: Featured buttons ----------
    for (const btn of $$('.cta-list .btn-featured')) {
      const cls = btn.dataset.imageClass;
      if (!cls) continue;
      const img = $(`.${cls}`);
      if (!img) continue;

      btn.addEventListener('mouseenter', () => img.classList.add('active'), { passive: true });
      btn.addEventListener('mouseleave', () => img.classList.remove('active'), { passive: true });
    }

    // ---------- Locate-a-rep ----------
    const mapContainer = $('#locate_a_rep');
    if (mapContainer) {
      const mapList = $('#map-list');

      // Click on state links inside mapList
      if (mapList) {
        on(mapList, 'click', '.rep-state', (e) => {
          e.preventDefault();
          const mapScrollTarget = $('#map-container');
          if (!mapScrollTarget) return;
          window.scrollTo({
            top: mapScrollTarget.offsetTop - 80,
            behavior: 'smooth'
          });
        });
      }

      // Toggle view buttons (guard against null mapList)
      on(mapContainer, 'click', '.view-toggle-btn', (e, button) => {
        e.preventDefault();
        $$('.view-toggle-btn', mapContainer).forEach(b => b.classList.remove('active'));
        button.classList.add('active');

        const view = button.dataset.view;
        if (mapList && view) {
          mapList.classList.remove('view-map', 'view-list');
          mapList.classList.add(`view-${view}`);
        }
      });
    }
  });
})();
